import type { FaireProductEntity } from "../../entity_types/product";

export const p_fqrea7r972: FaireProductEntity = {
  token: "p_fqrea7r972",
  type: "product",
  name: "Parker Half-Sleeve Sweater",
  brandToken: "b_2mvdyzg3tq",
  brandName: "Olivaceous",
  imageUrl:
    "https://cdn.faire.com/fastly/6df69ffc347724c70b15dacabc5c944e4f3d85cf6ce91f10511b59cc552383e5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8c759b4af32c70dca3fa496f18c5b78a5e3970dde1c87996ceeb2f4244b6f614.jpeg",
    "https://cdn.faire.com/fastly/bd7da3e80ecb95528f9833c0e0df98aba52f32d9464811ddc08e44f64e8bea56.jpeg",
    "https://cdn.faire.com/fastly/0f9145b9d2c10c66086ea4f98e12af1a2cff50cead36672bb610df19bf5095cb.jpeg",
    "https://cdn.faire.com/fastly/43ae458e8ffa584cfa34ddf1761e0ecb216e83c521a867c44204261458b79614.jpeg",
    "https://cdn.faire.com/fastly/bc30168bc2c947bd3cc8c47d9aebf58deeec9f4e9b812a5364c4e0d0141a80b4.jpeg",
    "https://cdn.faire.com/fastly/cf05d959f8e61866aa6507352b83649857df235bc16747d118391bd0b1c6188e.jpeg",
    "https://cdn.faire.com/fastly/00a9e54db148ed6305fb734b877df9a9e3acc25bb149ca7e3c63d9f840047f8d.jpeg",
    "https://cdn.faire.com/fastly/afcad56ba0081c4f171feddf175d4ef4a13f7f8f0792132302029ebb92932777.jpeg",
    "https://cdn.faire.com/fastly/bca67d7c0acb22b9703d540e90f164b4b83db465a3515bc624099391e2c2ee1f.jpeg",
    "https://cdn.faire.com/fastly/49bada5b1969207dd876df1a499a38ac11dc8bba7628dd557ec087fb09ef8b4a.jpeg",
    "https://cdn.faire.com/fastly/35864a2da22d3550d9f0c94bc85a9b8a61141c0f97155ff330c3d3fed02471e1.jpeg",
    "https://cdn.faire.com/fastly/8b4d420f76107667ef57a958e537adb2f5b9f98c126ae2b86cff650c84cd7129.jpeg",
    "https://cdn.faire.com/fastly/36d0047f5d56a44124ca727d08c2a1b1fae7f6886cd76f1639cc80cd8955bac0.jpeg",
    "https://cdn.faire.com/fastly/a1856de7e2a7e28c203917eb5b45e3b62e7baa8607d8df6fdd0fe2b808b44b67.jpeg",
    "https://cdn.faire.com/fastly/dc181a09489459e74f0a3af9abbcfde4b50bfc4cadd3fb229e3f78d6f35e57b4.jpeg",
    "https://cdn.faire.com/fastly/92ec2924333be77d73bf76a9460b35595ee68b385422e24c5bd7cee32cb10d72.jpeg",
    "https://cdn.faire.com/fastly/cc7669bc92fe62ddb684f84d68f93ac79b9243e1c92caef780ff401fd6585f15.jpeg",
    "https://cdn.faire.com/fastly/31b0bcc2e84e2845b8ac357e10da06529cf0ef395c11614e01e91e138c49951b.jpeg",
    "https://cdn.faire.com/fastly/bdb6a4981221300ab1edb82b66c9f9c1222fa7137341b5f64dc29b25d3b8d4af.jpeg",
    "https://cdn.faire.com/fastly/1dd4b46ee95bf1e73d1cab01e5b15ed6695c42c80b99abfa598d188f322a4b8a.jpeg",
    "https://cdn.faire.com/fastly/d8d02bd850f58e0bc1224c00fc19f13017b4be13544942c9286395d063d43b69.jpeg",
    "https://cdn.faire.com/fastly/6520c2c583f9f42ca318c9180770f275e62b1eacfcb34cc10d609e7e7c1b001e.jpeg",
  ],
  priceDollars: 140.63,
  description:
    "Our Parker Half-Sleeve Sweater features a subtle mock neck with a soft knit fabric for a cozy look and a relaxed boxy silhouette with ribbed hem and cuffs for clean structure.\n\nKnit",
  tags: [],
  msrpDollars: 281.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:14:53.695Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
